import router from '@/router';
import { kasseClient, productClient } from '../../../js/helpers/backend-clients';
import { displayAxiosError, hideLoadingOverlay, showLoadingOverlay, DATE_FORMATS, formatDate } from '@/js/helpers/utils';
import { setFile } from '@/plugins/axios';
import konstanten from '@/js/konstanten';
import objektartNdg from '@/js/objektartNdg';

const defaultState = () => {
  return {
    productNdg: {
      allgemeineAngaben: {},
      aussenwaende: {
        modernisierung: 'KEINE',
        jahrDerModernisierung: undefined,
        erlaeuterung: undefined,
        fotos: {
          aussenansichtVorne: undefined,
          aussenansichtHinten: undefined,
          offensichtlicheSchaeden: undefined,
          zusatzfoto: [],
        },
      },
      adresse: {},
      dach: {
        modernisierung: 'KEINE',
        jahrDerModernisierung: undefined,
        erlaeuterung: undefined,
        fotos: {
          dacheindeckungAussen: undefined,
          dachgeschossInnen: undefined,
          offensichtlicheSchaeden: undefined,
          zusatzfoto: [],
        },
      },
      fenster: {
        modernisierung: 'KEINE',
        jahrDerModernisierung: undefined,
        erlaeuterung: undefined,
        fotos: {
          hauseingangstuer: undefined,
          fenster: undefined,
          offensichtlicheSchaeden: undefined,
          zusatzfoto: [],
        },
      },
      fussboeden: {
        modernisierung: 'KEINE',
        jahrDerModernisierung: undefined,
        erlaeuterung: undefined,
        fotos: {
          fussboden1: undefined,
          fussboden2: undefined,
          fussboden3: undefined,
          offensichtlicheSchaeden: undefined,
          zusatzfoto: [],
        },
      },
      innenwaende: {
        modernisierung: 'KEINE',
        jahrDerModernisierung: undefined,
        erlaeuterung: undefined,
        fotos: {
          innentuer1: undefined,
          innentuer2: undefined,
          innenwand1: undefined,
          innenwand2: undefined,
          innenwand3: undefined,
          offensichtlicheSchaeden: undefined,
          zusatzfoto: [],
        },
      },
      decken: {
        modernisierung: 'KEINE',
        jahrDerModernisierung: undefined,
        erlaeuterung: undefined,
        fotos: {
          treppe1: undefined,
          treppe2: undefined,
          deckenkonstruktion1: undefined,
          deckenkonstruktion2: undefined,
          offensichtlicheSchaeden: undefined,
          zusatzfoto: [],
        },
      },
      sanitaer: {
        modernisierung: 'KEINE',
        jahrDerModernisierung: undefined,
        erlaeuterung: undefined,
        fotos: {
          bad1: undefined,
          bad2: undefined,
          offensichtlicheSchaeden: undefined,
          zusatzfoto: [],
        },
      },
      heizung: {
        modernisierung: 'KEINE',
        jahrDerModernisierung: undefined,
        erlaeuterung: undefined,
        fotos: {
          heizungsanlage1: undefined,
          heizungsanlage2: undefined,
          offensichtlicheSchaeden: undefined,
          zusatzfoto: [],
        },
      },
      technischeAusstattung: {
        modernisierung: 'KEINE',
        jahrDerModernisierung: undefined,
        erlaeuterung: undefined,
        fotos: {
          sicherungskasten: undefined,
          steckdosen: undefined,
          offensichtlicheSchaeden: undefined,
          zusatzfoto: [],
        },
      },
      objektunterlagen: {
        grundriss: undefined,
        zusatzdokumentGrundriss: undefined,
        energieausweis: undefined,
        zusatzdokumentEnergieausweis: undefined,
      },
      ansprechpartner: {},
      produkt: {},
      alternativeRechnung: {},
    },
    productKpa: {
      allgemeineAngaben: {},
      adresse: {},
      auftragsdaten: {},
      lasten: {},
      modernisierungen: {},
      auftragsdaten: {},
      kontaktdaten: {},
      produkt: {},
      alternativeRechnung: {},
      auftragsunterlagen: {
        grundbuchauszug: undefined,
        kaufvertrag: undefined,
        grundriss: undefined,
        mietvertraege: undefined,
        energieausweis: undefined,
        bauunterlagen: undefined,
        teilungserklaerung: undefined,
        zusatzdokument: [],
      }
    },
  };
};

const state = defaultState();

const mutations = {
  SET_PRODUCT_NDG(state, data) {
    state.productNdg = data;
  },
  SET_PRODUCT_KPA(state, data) {
    state.productKpa = data;
  },
  RESET_STATE(state) {
    Object.assign(state, defaultState());
  },
};

const actions = {
    setProductNdg({commit}, data) {
      commit('SET_PRODUCT_NDG', data);
    },
    setProductKpa({commit}, data) {
      commit('SET_PRODUCT_KPA', data);
    },
    loadProduct({dispatch}, {id, produktname}) {
      showLoadingOverlay();
      if (produktname.includes('Kaufpreisaufteilung')) {
          dispatch('loadProductKpa', id);
      } else {
          dispatch('loadProductNdg', id)
      }
    },
    duplicateProduct({dispatch}, {id, produktname}) {
      showLoadingOverlay();
      if (produktname.includes('Kaufpreisaufteilung')) {
          dispatch('duplicateProductKpa', id);
      } else {
          dispatch('duplicateProductNdg', id)
      }
    },
    loadProductNdg({state, commit}, id) {
        commit('RESET_STATE');
        let unwrap = ({ modernisierung, jahrDerModernisierung, erlaeuterung }) => ({
          modernisierung,
          jahrDerModernisierung,
          erlaeuterung,
        });
        productClient
          .productNdg(id)
          .then(({data}) => {
            let promises = [];
            const {
              allgemeineAngaben,
              adresse,
              aussenwaende,
              dach,
              fenster,
              fussboeden,
              innenwaende,
              decken,
              sanitaer,
              heizung,
              technischeAusstattung,
              objektunterlagen,
              ansprechpartner,
              produkt,
              alternativeRechnung
            } = data;

            Object.assign(state.productNdg.allgemeineAngaben, allgemeineAngaben);
            Object.assign(state.productNdg.adresse, adresse);
            Object.assign(state.productNdg.aussenwaende, unwrap(aussenwaende));
            Object.assign(state.productNdg.dach, unwrap(dach));
            Object.assign(state.productNdg.fenster, unwrap(fenster));
            Object.assign(state.productNdg.fussboeden, unwrap(fussboeden));
            Object.assign(state.productNdg.innenwaende, unwrap(innenwaende));
            Object.assign(state.productNdg.decken, unwrap(decken));
            Object.assign(state.productNdg.sanitaer, unwrap(sanitaer));
            Object.assign(state.productNdg.heizung, unwrap(heizung));
            Object.assign(state.productNdg.technischeAusstattung, unwrap(technischeAusstattung));
            Object.assign(state.productNdg.ansprechpartner, ansprechpartner);
            Object.assign(state.productNdg.produkt, produkt);
            Object.assign(state.productNdg.alternativeRechnung, alternativeRechnung);

            for (const [key, value] of Object.entries({
              aussenwaende,
              dach,
              fenster,
              fussboeden,
              innenwaende,
              decken,
              sanitaer,
              heizung,
              technischeAusstattung,
            })) {
              promises.push(
                ...value.fotos.map(f => {
                  return kasseClient.downloadFile('ndgmfh', f).then(response => {
                    setFile(response, 'ndgmfh', f, undefined, d => {
                      state.productNdg[key].fotos[konstanten.IMAGE_MAP[key][f]] = d;
                    });
                  });
                }),
              );
              for (let i = 0; i < value.zusatzFotos; i++) {
                promises.push(
                  kasseClient
                    .downloadIndexFile('ndgmfh', konstanten.IMAGE_MAP[key].zusatzfoto, i)
                    .then(response => {
                      setFile(response, 'ndgmfh', konstanten.IMAGE_MAP[key].zusatzfoto, i, d => {
                        state.productNdg[key].fotos.zusatzfoto.push(d);
                      });
                    }),
                );
              }
            }
            promises.push(
              ...objektunterlagen.map(f => {
                return kasseClient.downloadFile('ndgmfh', f).then(response => {
                  setFile(response, 'ndgmfh', f, undefined, d => {
                    state.productNdg.objektunterlagen[konstanten.IMAGE_MAP.objektunterlagen[f]] = d;
                  });
                });
              }),
            );
            Promise.all(promises).then(_ => {
              router.push('/produkt/ndg');
            })
          })
          .catch(error => displayAxiosError(error))
          .finally(() => hideLoadingOverlay());
    },
    loadProductKpa({state, commit}, id) {
        commit('RESET_STATE');
        productClient
          .productKpa(id)
          .then(({data}) => {
            let promises = [];
            const {
              allgemeineAngaben,
              adresse,
              auftragsdaten,
              lasten,
              modernisierungen,
              auftragsunterlagen,
              produkt,
              kontaktdaten,
              alternativeRechnung
            } = data;
            Object.assign(state.productKpa.allgemeineAngaben, allgemeineAngaben);
            Object.assign(state.productKpa.adresse, adresse);
            Object.assign(state.productKpa.auftragsdaten, auftragsdaten);
            Object.assign(state.productKpa.lasten, lasten);
            Object.assign(state.productKpa.modernisierungen, modernisierungen);
            Object.assign(state.productKpa.kontaktdaten, kontaktdaten);
            Object.assign(state.productKpa.produkt, produkt);
            Object.assign(state.productKpa.alternativeRechnung, alternativeRechnung);

            for (let i = 0; i < auftragsunterlagen.zusatzdokument; i++) {
              promises.push(
                kasseClient
                  .downloadIndexFile('kpa', '_unterlagen_zusatz', i)
                  .then(response => {
                    setFile(response, 'kpa', '_unterlagen_zusatz', i, d => {
                      state.productKpa.auftragsunterlagen.zusatzdokument.push(d);
                    });
                  }),
              );
            }
            promises.push(
              auftragsunterlagen.unterlagen.filter(f => '_unterlagen_zusatz' !== f).map(f => {
                return kasseClient.downloadFile('kpa', f).then(response => {
                  setFile(response, 'kpa', f, undefined, d => {
                    state.productKpa.auftragsunterlagen[konstanten.KPA_DOKUMENT_MAP[f]] = d;
                  });
                });
              }),
            );
            Promise.all(promises).then(_ => {
              router.push('/produkt/kpa');
            })
          })
          .catch(error => displayAxiosError(error))
          .finally(() => hideLoadingOverlay());
    },
    duplicateProductNdg({dispatch}, id) {
        showLoadingOverlay();
        productClient
          .productNdg(id, true)
          .then((data) => {
            dispatch('product/setObjektart', objektartNdg[data.data.allgemeineAngaben.objektart]?.text, {root: true});
            dispatch('product/setObjektbesichtigung', data.data.allgemeineAngaben.objektbesichtigung, {root: true});
            data.data = {
              ...data.data,
              allgemeineAngaben: {
              ...data.data.allgemeineAngaben,
              ermittlungsstichtag: formatDate(data.data.allgemeineAngaben.ermittlungsstichtag, DATE_FORMATS.UI_DATE_FORMAT, DATE_FORMATS.API_DATE_FORMAT)
              }
            };
            const { objektbesichtigung } = data.data.allgemeineAngaben;
            switch (objektbesichtigung) {
              case 'BESICHTIGUNG':
                dispatch('objektbesichtigung/loadObjektbesichtigung', data, {root: true});
                break;
              case 'KEINE':
                dispatch('gutachten/loadGutachten', data, {root: true});
                break;
            }
          })
          .catch(error => displayAxiosError(error))
          .finally(() => hideLoadingOverlay());
    },
    duplicateProductKpa({dispatch}, id) {
        showLoadingOverlay();
        productClient
          .productKpa(id, true)
          .then((data) => {
             data.data = {
              ...data.data,
              allgemeineAngaben: {
              ...data.data.allgemeineAngaben,
              ermittlungsstichtag: formatDate(data.data.allgemeineAngaben.ermittlungsstichtag, DATE_FORMATS.UI_DATE_FORMAT, DATE_FORMATS.API_DATE_FORMAT)
              }
            };
            dispatch('kaufpreisaufteilung/loadKaufpreisauteilung', data, {root: true});
          })
          .catch(error => displayAxiosError(error))
          .finally(() => hideLoadingOverlay());
    }
}

const getters = {
  productNdg: () => state.productNdg,
  productKpa: () => state.productKpa,
}

const gekaufeProdukteModule = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export default gekaufeProdukteModule;